import React from 'react';
import { PopupModal } from 'react-calendly';

const CalendlyPopup = ({ isOpen, onClose }) => {
  return (
    <PopupModal
      url={process.env.REACT_APP_CALENDLY_URL || "https://calendly.com/d/cynj-pqr-22y/traain-discovery"}
      onModalClose={onClose}
      open={isOpen}
      rootElement={document.getElementById('root')}
    />
  );
};

export default CalendlyPopup;
